import React from 'react'

import useFreedomPayHpcSessionKey from '~/hooks/freedom-pay-hpc-session-key'
import useFeatureFlags from '~/hooks/use-feature-flags'

import FreedomPayHpcSessionKeyContext from './freedom-pay-hpc-session-key.context'

import type { ComponentType, ReactNode } from 'react'

export function FreedomPayHpcSessionKeyProvider({
  children,
}: {
  children: ReactNode
}) {
  const { creditCardEntryWithFreedompay } = useFeatureFlags()

  return creditCardEntryWithFreedompay ? (
    <RealFreedomPayHpcSessionKeyProvider>
      {children}
    </RealFreedomPayHpcSessionKeyProvider>
  ) : (
    <MockFreedomPayHpcSessionKeyProvider>
      {children}
    </MockFreedomPayHpcSessionKeyProvider>
  )
}

function RealFreedomPayHpcSessionKeyProvider({
  children,
}: {
  children: ReactNode
}) {
  const value = useFreedomPayHpcSessionKey()

  return (
    <FreedomPayHpcSessionKeyContext.Provider value={value}>
      {children}
    </FreedomPayHpcSessionKeyContext.Provider>
  )
}

function MockFreedomPayHpcSessionKeyProvider({
  children,
}: {
  children: ReactNode
}) {
  const mockValue = [null, true, () => {}]

  return (
    <FreedomPayHpcSessionKeyContext.Provider value={mockValue}>
      {children}
    </FreedomPayHpcSessionKeyContext.Provider>
  )
}

export const withFreedomPayHpcSessionKeyProvider =
  () => (Component: ComponentType<any>) => (props: any) => (
    <FreedomPayHpcSessionKeyProvider>
      <Component {...props} />
    </FreedomPayHpcSessionKeyProvider>
  )
